import { createReducer } from '@reduxjs/toolkit';

import { IPayoutLimitsReducer } from '../payoutLimits/types';

import { loadPaymentLimitsListSuccess, loadPaymentLimitsStart } from './actions';

const initialState: IPayoutLimitsReducer = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const PaymentLimitsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loadPaymentLimitsStart, (state) => ({ ...state, isLoading: true }))
    .addCase(loadPaymentLimitsListSuccess, (state, action) => ({ ...state, isLoading: false, isLoaded: true, data: action.payload }));
});

export default PaymentLimitsReducer;
